import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { dispatchFormEvent } from "../../../services/form/thunks";
import useAlert from "./Alert";

function useFormEventDispatcher({ 
  setLoading
}) {
  const { id, type: formType } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clear } = useAlert()
  
  return useCallback(
    async (action, form) => {
      const formData = form ? new FormData(form) : {};
      const payload = Object.fromEntries(formData.entries());

      try {
        clear()
        setLoading(true);
        const response = await dispatch(
          dispatchFormEvent({ formId: id, formType, body: payload, action })
        ).unwrap();
        if (response?.redirectPath) {
          navigate(response.redirectPath, { replace: true });
        }
      } finally {
        setLoading(false);
      }
    },
    [clear, dispatch, formType, id, navigate, setLoading]
  );
}

export default useFormEventDispatcher;
